import { QueryRequestContextProps, QueryState, initialQueryRequest } from 'components/table/types';
import { FC, createContext, useContext, useState } from 'react';
import { WithChildren } from 'ts-types';

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest);

type Props = WithChildren & {
  initialState?: QueryState;
};

const QueryRequestProvider: FC<Props> = ({ children, initialState }) => {
  const [state, setState] = useState<QueryState>(() => initialState ?? initialQueryRequest.state);

  const updateState = (updates: Partial<QueryState>) => {
    setState((prev) => ({ ...prev, ...updates } as QueryState));
  };

  return <QueryRequestContext.Provider value={{ state, updateState }}>{children}</QueryRequestContext.Provider>;
};

const useQueryRequest = () => useContext(QueryRequestContext);

export { QueryRequestProvider, useQueryRequest };
